module.exports = __webpack_public_path__ + "img/NewAdminBackground.d1aa2a39.jpg";